export const RACE_DISTANCES = [
  '5k',
  '10k',
  'Half Marathon',
  'Marathon',
  'Other',
];
